import { connect } from 'react-redux';
import FAQPage from '../components/pages/FAQPage';
import withTranslate from '../components/withTranslate';

const mapStateToProps = ({ language }) => ({
  currentLanguage: language.currentLanguage,
});

export default withTranslate(connect(mapStateToProps, null)(FAQPage));
